import CustomInput from '../reusable/input';
import LabelWrapper from '../wrapper/label';
import PasswordValidation from '../validation/password';
import { setPasswordSchema } from '../../schema/customer_schema';
import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import { Form, Formik } from 'formik';

const StyledForm = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
}));

interface SignupParams {
    password: string;
    confirm_password: string;
}

interface CustomerSignUpProps {
    submitHanlder: (value: string) => void
}

const CustomerSignUpStep1 = ({ submitHanlder }: CustomerSignUpProps) => {
    const initialValues: SignupParams = {
        password: '',
        confirm_password: ''
    };

    const handleSubmit = (values: SignupParams) => {
        submitHanlder(values.password);
    };

    return <Formik
        initialValues={initialValues}
        validationSchema={setPasswordSchema}
        onSubmit={handleSubmit}
    >
        {({ values, handleChange, handleBlur, errors, touched }) => (
            <Form style={{ width: '100%' }}>
                <StyledForm>
                    <CustomInput
                        type="password"
                        label="Password"
                        placeholder="············"
                        value={values.password}
                        onChange={handleChange('password')}
                        onBlur={handleBlur('password')}
                        error={touched.password && errors.password}
                        fullWidth
                    />
                    <CustomInput
                        type="password"
                        label="Confirm Password"
                        placeholder="············"
                        value={values.confirm_password}
                        onChange={handleChange('confirm_password')}
                        onBlur={handleBlur('confirm_password')}
                        error={touched.confirm_password && errors.confirm_password}
                        fullWidth
                    />
                    <LabelWrapper marginBottom="0" label="Password must contain" />
                    <PasswordValidation password={values.password} />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                    >
                        Next
                    </Button>
                </StyledForm>
            </Form>
        )}
    </Formik>;
};

export default CustomerSignUpStep1;